import React, { useState, useRef } from 'react';
import logo from '../assets/logo_2.png';
import '../component/home.css';
import axios from 'axios';
import Assesment from '../component/Assesment';
import { useNavigate } from 'react-router-dom';
import loginlogo from'../assets/Untitled-10.png';
import pullellogo from '../assets/PULLALA.png';
import nodic from '../assets/NH.png';
import login from '../assets/nSure_CSSH_LOGO.svg'




const Home = () => {

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('Process env', apiUrl);
  
  const formStyle = {
 color:'white',
    textAlign: 'center',
    fontSize: '30px',
    lineheight: '30px',
    
  };
  const formRef = useRef(null); // Form reference
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    mobile: '',
    gender: '',
    date: '',
    assesmentdata: '' ,
    pdf_path:null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const userPost = async () => {
    console.log(formData);
    try {
      let response = await axios.post('https://nsureback.asianspinehospital.com/user', formData);
      console.log(response.data);
      sessionStorage.setItem('formData', JSON.stringify(formData));
      navigate('/login');
    } catch (error) {
      alert('Error posting form data because user may be already submitted form' );
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();  
    
    userPost();
    setFlag(true);
    
    formRef.current.reset();
    // setFormData({
    //   name: '',
    //   age: '',
    //   mobile: '',
    //   gender: '',
    //   date: '',
    //   assesmentdata: '',
    // }); 
     
      
  };

  return (
    <>
     <div className='homefullpage'>
        {/* Left side */}
        <div className='homeleftside'>
          
          <div className='leftsideui'>
            <img className='loginlogo' src={loginlogo} alt='loginlogo'/>            
            <h2 style={formStyle} >India's First Integrated Preventive <br/>SPINE & SPORTS Healthcare Center</h2>
            <div className='partnerlogo '>
              <h2 > In Partnership With</h2>
              <div className='imgmanner'>
            <img className='pullellogo' src={pullellogo} alt='pullellogo'/>
            <img className='nodic' src={nodic} alt='nodic'/>
            </div>
            </div>
          </div>
        </div>

        {/* Right side */}
        <div className='homerightside'>
  
          <img src={login} className='logosize' alt='logo' />
          <div className='heading'>Spine Health Assessment</div>

          {/* Form */}
          <form ref={formRef} onSubmit={handleSubmit} className='forms'>
            <div className='formdata'>
              <div className='input_design'>
                <input
                  className='inpu'
                  placeholder='Name'
                  type='text'
                  name='name'
                  onChange={handleChange}
                  value={formData.name}
                  required
                />
              </div>
              <div className='input_design'>
                <input
                  className='inpu'
                  type='tel'
                  name='mobile'
                  placeholder='Ph.No'
                  onChange={handleChange}
                  value={formData.mobile}
                  minLength={10}
                  maxLength={10}
                  pattern="[0-9]{10}" 
                  required
                />
              </div>
              <div className='input_design'>
                <select
                  className='inpu os'
                  name='assesmentdata'  // Input name now matches the state key
                  onChange={handleChange}
                  value={formData.assesmentdata}
                  minLength={10}
                  required
                >
                  <option value="">Assesment category</option>
                  <option value='NECK & UPPER BACK PAIN'>NECK & UPPER BACK PAIN</option>
                  <option value='LOWER BACK PAIN'>LOWER BACK PAIN</option>
                </select>
              </div>
              <div className='input_mix'>
                <div className='input_design'>
                  <input
                    className='inpu'
                    placeholder='Age'
                    type='number'
                    name='age'
                    onChange={handleChange}
                    value={formData.age}
                    min={1}
                    required
                  />
                </div>
                <div className='input_design'>
                  <select   className='inpu os'
                    name='gender'
                    // minLength={1}
                    required
                    onChange={handleChange}
                    value={formData.gender}
                    >
                      <option value=''>
                      Gender
                    </option>
                    <option value='M'>
                      M
                    </option>
                    <option value='F'>
                      F
                    </option>
                  </select>
                </div>
                <div className='input_design'>
                  <input
                    className='inpu'
                    placeholder='Date'
                    type='date'
                    name='date'
                    onChange={handleChange}
                    value={formData.date}
                    required
                  />
                </div>
              </div>
              <input type='submit' value='Enter' />
            </div>
          </form>
        </div>
    
      </div>
    </>
  );
};

export default Home;
